import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { EventActions, EventNames } from '../../shared/constants/analytics';
import useTracking from '../hooks/useTracking';

function TrackInstEvents() {
  const { trackEvent } = useTracking();
  const { slug } = useParams();

  useEffect(() => {
    if (slug) {
      const eventLabel = slug.replace(/[\s-]/g, '_').toLowerCase();

      trackEvent(EventNames.WellBeingDashboard, {
        eventLabel,
        eventAction: EventActions.click,
        eventCategory: eventLabel,
        eventValue: eventLabel,
        eventSource: 'side_bar',
      });
    }
  }, [slug]);
}

export default TrackInstEvents;
